import { actionTree, getterTree, mutationTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'
import { Store } from '~/types/store'

export const EASY_APPLY_TAB = 'easy'
export const GAME_TAB = 'dashboard'
export const RECOMMENDED_TAB = 'recommended'
export const ALL_TAB = 'matches'
export const PICKED_TAB = 'saved'
export const STARTED_TAB = 'started'
export const SENT_TAB = 'submitted'
export const IGNORED_TAB = 'ignored'
export const RESOURCES_TAB = 'resources'
export const ACTIVE_SUB_TAB = 'active'
export const CLOSED_SUB_TAB = 'closed'

export const tabList = {
  [EASY_APPLY_TAB]: {
    name: 'Easy apply',
    iconName: 'trophy'
  },
  [GAME_TAB]: {
    name: 'Dashboard',
    iconName: 'game-square-cross'
  },
  [RECOMMENDED_TAB]: {
    name: 'Recommended',
    iconName: 'two-flags'
  },
  [ALL_TAB]: {
    name: 'Matches',
    iconName: 'card-stack'
  },
  [PICKED_TAB]: {
    name: 'Saved',
    iconName: 'thin-heart'
  },
  [STARTED_TAB]: {
    name: 'Started',
    iconName: 'curved-document'
  },
  [SENT_TAB]: {
    name: 'Submitted',
    iconName: 'assignment-turned-in'
  },
  [IGNORED_TAB]: {
    name: 'Ignored',
    iconName: 'not-interested'
  },
  [RESOURCES_TAB]: {
    name: 'Resources',
    iconName: 'star-outline'
  }
}

const propertyIntersection = (propNames: string[], obj: Store.SideBar.TabList) => propNames.reduce((acc, name) => {
  acc[name] = obj[name]
  return acc
}, {} as Store.SideBar.TabList)

export const state = () => ({
  isSideBarOpen: false
})

export const getters = getterTree(
  state,
  {
    tabList: (state, getters, rootState, { 'account/isPro': isPro, 'featureSet/isGame': isGame }) => {
      const coreTabs = [PICKED_TAB, STARTED_TAB, SENT_TAB, IGNORED_TAB, RESOURCES_TAB]
      if (isGame) { return propertyIntersection([GAME_TAB, RECOMMENDED_TAB, EASY_APPLY_TAB, ALL_TAB, ...coreTabs], tabList) }
      return propertyIntersection([RECOMMENDED_TAB, EASY_APPLY_TAB, ALL_TAB, ...coreTabs], tabList)
    }
  }
)

export const mutations = mutationTree(
  { state },
  {
    setState
  }
)

export const actions = actionTree(
  { state },
  {
    toggleSideBar({ state, commit }) {
      if (state.isSideBarOpen) {
        commit('setState', { stateName: 'isSideBarOpen', data: false })
      } else {
        commit('setState', { stateName: 'isSideBarOpen', data: true })
      }
    }
  }
)
